import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import 'moment/locale/ar';
@Pipe({
  name: 'time'
})
export class TimePipe implements PipeTransform {
  currentLanguage: string;
  transform(value: string, args: string = 'hh:mm A'): string {
    if (localStorage.getItem('lang')) this.currentLanguage = localStorage.getItem('lang');
    else this.currentLanguage = 'en';
    if (moment('2000-01-01 ' + value).isValid()) return moment('2000-01-01 ' + value).locale(this.currentLanguage).format(args);
    return value;
  }
}
